module.exports = __webpack_public_path__ + "static/media/belgaColor.6d8f587d.svg";